import React from "react"
import PropTypes from "prop-types"
import { SiteMeta } from "datastory-shared/sections"

import { SerivceLayout } from "components/layouts"

export default function withService(Service) {
  const WithService = props => {
    const { service } = props
    const meta = {
      image: service?.og_image[0]?.entity_meta?.local_id,
      title: service?.og_name[0]?.i18n,
      description: service?.og_description[0]?.i18n,
    }

    return (
      <>
        <SiteMeta {...meta} />
        <SerivceLayout {...props}>
          <Service {...props} />
        </SerivceLayout>
      </>
    )
  }
  WithService.propTypes = {
    service: PropTypes.object,
  }

  WithService.displayName = `WithService(${
    Service.displayName || Service.name || "Component"
  })`

  return WithService
}
